import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import { ALL_LOAN_TYPES } from "@/lib/constants";
import { QuickFormMain } from "@/components/quickForm/quickFormMain";
import { ConsultationForm } from "@/components/consultationForm/consultationForm";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);
	const [loan, setLoan] = useState<string | undefined>(undefined);

	useEffect(() => {
		setComponent(rootElement?.dataset.component?.toLowerCase());
		setSiteTitle(rootElement?.dataset.title);
	}, [rootElement]);

	const renderComponent = () => {
		if (component === "consultation") {
			return <ConsultationForm rootElement={rootElement} />;
		} else {
			return (
				<QuickFormMain
					rootId={rootElement}
					loanTypes={ALL_LOAN_TYPES}
					siteTitle={siteTitle}
				/>
			);
		}
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
